import { render, staticRenderFns } from "./Candidates.vue?vue&type=template&id=2a47289b&scoped=true&"
import script from "./Candidates.vue?vue&type=script&lang=js&"
export * from "./Candidates.vue?vue&type=script&lang=js&"
import style0 from "./Candidates.vue?vue&type=style&index=0&id=2a47289b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a47289b",
  null
  
)

export default component.exports